import React, { Component } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { UserState } from '../../../redux/reducers/UserReducer';
import Button from '../../atoms/Button';
import Modal from '../../molecules/Modal';

interface LogoutModalHandler {
  loginUser: UserState;
  logout: (loginUser: UserState, history: any) => void;
}

interface LogoutModalProps extends RouteComponentProps, LogoutModalHandler {
  isOpen: boolean;
  onClose: () => void;
}

class LogoutModal extends Component<LogoutModalProps, {}> {
  constructor(props: LogoutModalProps) {
    super(props);
    this.onClose = this.onClose.bind(this);
  }

  onClose() {
    this.setState({ anchorEl: null });
    this.props.onClose();
  }

  render() {
    const { isOpen, loginUser, logout } = this.props;
    return (
      <Modal open={isOpen} hasFade={false} onBackdropClick={this.onClose} onEscapeKeyDown={this.onClose} surfaceClassName='u-mv-auto'>
        <Modal.Header onClickClose={this.onClose} className='u-pb16' data-testid='logout-title'>
          ログアウトしますか？
        </Modal.Header>
        <div className='uc-divider' />
        <Modal.Actions>
          <Button label='キャンセル' type='secondary' onClick={this.onClose} data-testid='logout-cancel' />
          <Button label='ログアウト' onClick={() => logout(loginUser, this.props.history)} data-testid='logout-exec' />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withRouter(LogoutModal);
